import React from 'react';
import { Paper, Box, Typography, Grid } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import BaseTopBar from 'components/elements/molecules/TopBar';
import ButtonGoBack from 'components/elements/atoms/ButtonGoBack';

import useStyles from './styles';
import { useTranslations } from 'components/utilities';

const TopBar = () => {
	const classes = useStyles();

	const { t } = useTranslations();

	return (
		<BaseTopBar
			title={t('booking.header')}
			actions={
				<Box pl={1}>
					<ButtonGoBack />
				</Box>
			}
			oneLine
			stickyBar={
				<Paper square elevation={2} className={classes.stickyBar}>
					<Box px={3} py={2}>
						<Typography variant="h5">
							<Grid container spacing={1} justify="center" alignItems="center">
								<Grid item xs="auto">
									{t('booking.subHeader')}
								</Grid>
								<Grid item xs="auto">
									<CheckCircleOutlineIcon fontSize="large" />
								</Grid>
							</Grid>
						</Typography>
					</Box>
				</Paper>
			}
		/>
	);
};

export default TopBar;
